import Vue from 'vue';

Vue.use({
  install: Vue => {
    Vue.prototype.$assets = {
      icon(imageName) {
        return `${process.env.VUE_APP_ASSETS_URL}/icons/${imageName}`;
      },
      image(imageName) {
        return `${process.env.VUE_APP_ASSETS_URL}/images/${imageName}`;
      },
    };
  },
});
